import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './AutoshipmentLogoLockup.module.scss.js';
import { localeLogoMapping, LOGO_ZOOPLUS_RELAX, LOGO_BITIBA_ABO } from './localeLogoMapping.js';

const { componentTestLabel } = getTestLabels('AutoshipmentLogoLockup');
/**
 * [design (Figma)](https://www.figma.com/file/XpsesTqoYjoiDj1pqxcDL5/Images%2C-Illustrations%E2%80%A8-%26-Logos?type=design&node-id=1235-317&mode=design&t=bAV3MOUKn6cBuY5w-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Autoshipment/AutoshipmentLogoLockup/AutoshipmentLogoLockup.tsx)
 *
 * @param {Locale} locale - (optional) The current locale determines which logo is displayed for the language[+country] of the locale.
 * @param {Realm} realm - (optional) One of `bitiba` or `zooplus` (defaults to `zooplus`).
 * @param {AutoshipmentLogoSizes} size - (optional) Size of the logo. One of `small` or `medium`. (defaults to `small`).
 * @param {('light')} variant - (optional) Can be set to `light` for usage on dark backgrounds.
 * @param {AutoshipmentLogoVerticalAlignments} verticalAlign - (optional) Applies a CSS `vertical-align` value. Can be one of `bottom`, `baseline`, `middle`, or `top`.
 */
const AutoshipmentLogoLockup = (props) => {
    const { className, locale = 'en', size, style: authorStyle, realm = 'zooplus', variant, verticalAlign, ...otherProps } = props;
    const attrs = {
        'data-zta': componentTestLabel,
        ...otherProps,
        className: classNames(className, style['z-autoshipment-logo-lockup'], {
            [style['z-autoshipment-logo-lockup--medium']]: size === 'medium',
            [style['z-autoshipment-logo-lockup--light']]: variant === 'light',
        }),
        style: {
            ...authorStyle,
            '--pp-AutoshipmentLogoLockup-valign': verticalAlign,
        },
    };
    let logoData = {};
    if (localeLogoMapping[locale][realm]) {
        // use the mapped locale and realm combo if available
        logoData = localeLogoMapping[locale][realm];
    }
    else if (realm === 'zooplus') {
        // if realm is zooplus, but locale+realm combo is not mapped, then use 'zooplus relax'
        logoData = LOGO_ZOOPLUS_RELAX;
    }
    else {
        // if realm is not zooplus (ie bitiba), but locale+realm combo is not mapped, then use 'bitiba-Abo'
        logoData = LOGO_BITIBA_ABO;
    }
    return (jsx("img", { loading: props.loading || 'lazy', ...attrs, src: `https://cdn.public.zooplus.net/media/ui-components/v6-latest/svg/${logoData.file}.svg`, alt: props.alt || logoData.alt, width: logoData[size === 'medium' ? 'widthMedium' : 'width'], height: size === 'medium' ? '28' : '20' }));
};

export { AutoshipmentLogoLockup };
//# sourceMappingURL=AutoshipmentLogoLockup.js.map
